import React from "react";

import { defineMessages, useIntl } from "react-intl";
import { Link } from "react-router-dom";

import { Alert } from "@mapmycustomers/ui";

import Path from "@app/enum/Path";
import { ClassName } from "@app/types/ui/ClassName";

const messages = defineMessages({
  manageSubscriptionAction: {
    id: "integrations.edit.limitAlert.manageSubscriptionAction",
    defaultMessage: "Manage Subscription",
    description: "Limit Alert link text on Edit Integrations Screen",
  },
  text: {
    id: "integrations.edit.limitAlert.message",
    defaultMessage:
      "Integrations for Free Trial accounts are limited to 25,000 records. To sync without limits, sign up for a paid account.",
    description: "Limit Alert message on Overview Screen.",
  },
});

const LimitAlert: React.FC<ClassName> = ({ className }) => {
  const intl = useIntl();

  return (
    <Alert
      action={[
        <Link key="subscribe" to={Path.BILLING}>
          {intl.formatMessage(messages.manageSubscriptionAction)}
        </Link>,
      ]}
      className={className}
      message={intl.formatMessage(messages.text)}
      type="warning"
    />
  );
};

export default LimitAlert;
